import { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import '../css/demo.css';

import Alert from '../../common/components/Alert';
import DynamicHeightContext from '../../common/context/DynamicHeightContext';
import { isDemoMode } from '../../common/utility';

const messages = defineMessages({
  demoAlertTitle: {
    id: 'demo.alert.title',
    description: 'DEMO NOTICE',
    defaultMessage: 'DEMO NOTICE: Everything is Read-Only!',
  },
  demoNoFunctionality: {
    id: 'demo.alert.no_functionality',
    description: 'Info that this functionality is not included in the demo.',
    defaultMessage: 'This function is not included in the demo.',
  },
});

export const DemoNoFunctionality: React.FC = () => {
  const { formatMessage } = useIntl();

  if (!isDemoMode()) return null;

  return (
    <Alert severity='info' className='demo-alert demo-no-margin' title={formatMessage(messages.demoNoFunctionality)}>
      {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
      {''}
    </Alert>
  );
};

const Demo: React.FC = () => {
  const { formatMessage } = useIntl();

  const dynamicHeightContext = useContext(DynamicHeightContext);

  if (!isDemoMode()) return null;

  return (
    <div
        className = 'list-error'
        style = {{ marginTop: `${(dynamicHeightContext.toolbarHeight) + 5}px`, marginBottom: `-${dynamicHeightContext.toolbarHeight}px` }}>
      <Alert severity='info' className='demo-alert demo-no-margin' title={formatMessage(messages.demoAlertTitle)}>
        {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
        {''}
      </Alert>
    </div>
  );
};

export default Demo;
